/**
 * Saudação da tela de login, por faixa de horário local do navegador.
 *
 * Função pura (recebe a data) para ser testável sem relógio global. As faixas
 * seguem o uso comum no Brasil: manhã até 11h59, tarde até 17h59, noite até
 * 23h59 e madrugada de 0h às 4h59 — esta última ganha um texto mais afetuoso,
 * porque quem entra a essa hora merece reconhecimento, não um "boa noite"
 * seco. A frase da madrugada cita o Claude de propósito (pedido do time).
 */
export function greetingFor(date: Date): string {
  const hour = date.getHours();
  if (hour < 5) return "Madrugada por aqui, time? O Claude também está de plantão com a gente.";
  if (hour < 12) return "Bom dia, time";
  if (hour < 18) return "Boa tarde, time";
  return "Boa noite, time";
}
